import { formatStatusLabel } from "@/lib/utils";

// Two-line "SYMBOL" / "Network" pairing — symbol on top, network muted and
// sentence-cased underneath — used wherever a table needs to show which
// asset+chain a row is on without a full column (or a colored badge) for
// the network. `inline` collapses this to one line ("SYMBOL · Network"),
// for detail pages where the two-line stack reads as oddly tall next to a
// single label — tables should leave it at the default (two lines), so a
// column of these stays vertically compact and every row's baseline lines up.

export interface AssetLabelProps {
  symbol: string;
  network: string;
  inline?: boolean;
}

export function AssetLabel({ symbol, network, inline = false }: AssetLabelProps) {
  if (inline) {
    return (
      <span className="inline-flex items-baseline gap-1.5">
        <span className="font-semibold">{symbol}</span>
        <span aria-hidden className="text-muted-foreground">·</span>
        <span className="text-xs text-muted-foreground">{formatStatusLabel(network)}</span>
      </span>
    );
  }
  return (
    <span>
      <span className="block font-semibold">{symbol}</span>
      <span className="block text-xs text-muted-foreground">{formatStatusLabel(network)}</span>
    </span>
  );
}
